<template>
  <div>
    <FilterBarSkeletonLoader v-if="pageLoading || componentLoading" />
    <div v-else>
      <div v-if="$route.query.view === 'chrome' || isDatapeopleAnywhereEditor">
        <ChromeNavbar
          :job-id="subMenuProps.jobId"
          :all-revisions="subMenuProps.allRevisions"
          :current-revision-id="subMenuProps.revisionId"
          @tracking-event="handleTrackingEvent($event)"
        />
      </div>
      <div v-else>
        <SideBySideSubMenu
          v-if="sideBySideView"
          :job-id="subMenuProps.jobId"
          :word-count="subMenuProps.wordCount"
          :specificity-key="specificityKey"
          :specificity-data="specificityData"
          @tracking-event="handleTrackingEvent($event)"
        />
        <SubMenu
          v-else
          v-bind="subMenuProps"
          :is-data-loaded="!pageLoading"
          @tracking-event="handleTrackingEvent($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>

import SubMenu from '@/components/editor/SubMenu.vue';
import ChromeNavbar from '@/components/editor/ChromeNavbar.vue';
import SideBySideSubMenu from '@/components/editor/SideBySideSubMenu.vue';
import FilterBarSkeletonLoader from '@/components/shared/SkeletonLoaders/FilterBarSkeletonLoader.vue';
import { mapState } from 'pinia';
import { useTracking } from '@/stores/tracking/tracking';
import { useAppLoading } from '@/stores/app/loading';
import { useDatapeopleAnywhereEditor } from '@/stores/document/datapeopleAnywhereEditor';
import { useEditor } from '@/stores/editor/editor';

export default {
  name: 'EditorSubMenu',
  components: {
    SubMenu, ChromeNavbar, SideBySideSubMenu, FilterBarSkeletonLoader,
  },
  computed: {
    ...mapState(useAppLoading, ['pageLoading', 'componentLoading']),
    ...mapState(useDatapeopleAnywhereEditor, ['isDatapeopleAnywhereEditor']),
    ...mapState(useEditor, [
      'subMenuProps', 'sideBySideView', 'specificityKey', 'specificityData',
    ]),
  },
  methods: {
    handleTrackingEvent({ action, args }) {
      useTracking()[action](args);
    },
  },
};
</script>
